var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.424,
    height: 27.417,
    viewBox: "0 0 27.424 27.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39256",
    "data-name": "Group 39256",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39255",
    "data-name": "Group 39255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28631",
    "data-name": "Path 28631",
    d: "M2646.948,989.359V974.166c.01-.015.026-.028.028-.044a2.472,2.472,0,0,1,2.628-2.129c.533.022,1.068.015,1.6,0a1.192,1.192,0,0,0,.539-.142c2.7-1.563,5.386-3.156,8.1-4.7a32.566,32.566,0,0,1,4.557-2.5h.631a2.981,2.981,0,0,1,2.163,1.762c1,1.808,2.046,3.589,3.066,5.385a.474.474,0,0,0,.384.264,2.2,2.2,0,0,1,1.1.51,2.476,2.476,0,0,1,.9,2.015c0,1.13,0,2.26,0,3.391a.32.32,0,0,0,.2.343,1.723,1.723,0,0,1,1.016,1.6q.029,1.866,0,3.732a1.733,1.733,0,0,1-1.021,1.594.3.3,0,0,0-.195.317q.009,1.7,0,3.391a2.628,2.628,0,0,1-.251,1.222,2.436,2.436,0,0,1-2.318,1.393q-4.429.006-8.858,0-5.835,0-11.67,0a2.5,2.5,0,0,1-2.119-1.008A2.85,2.85,0,0,1,2646.948,989.359Zm24.452-3.906h-.356c-1.218-.009-2.438.036-3.651-.038a3.661,3.661,0,0,1,.375-7.3c1.113-.009,2.225,0,3.338,0h.291a1.473,1.473,0,0,0,.018-.152c0-1.156.011-2.313,0-3.469a1.214,1.214,0,0,0-1.353-1.271q-10.262,0-20.525,0a1.782,1.782,0,0,0-.417.037,1.251,1.251,0,0,0-.948,1.363q0,6.386,0,12.772,0,.815,0,1.629a1.151,1.151,0,0,0,.548,1.1,1.968,1.968,0,0,0,.9.222q10.184.018,20.368.009a2.575,2.575,0,0,0,.314-.014,1.152,1.152,0,0,0,1.1-1.08C2671.417,988,2671.4,986.749,2671.4,985.453Zm-1.651-1.247v.016c.7,0,1.4,0,2.1,0,.571,0,.793-.223.794-.794q0-1.642,0-3.285c0-.586-.226-.814-.805-.815-1.313,0-2.627-.009-3.941.006a3.513,3.513,0,0,0-.9.136,2.424,2.424,0,0,0,.546,4.729C2668.277,984.235,2669.014,984.206,2669.749,984.206Zm-3.948-17.722a1.184,1.184,0,0,0-1.708-.4q-4.958,2.882-9.912,5.771c-.048.028-.09.065-.2.142.742,0,1.413.009,2.082-.006a1.116,1.116,0,0,0,.515-.137q4.5-2.6,8.986-5.224C2665.642,966.586,2665.714,966.539,2665.8,966.484Zm-6.918,5.454.018.058c.687,0,1.375.007,2.062-.005a.953.953,0,0,0,.441-.121q2.7-1.56,5.4-3.137c.073-.042.141-.092.219-.143l-.6-1.043Zm8.752-2.276-3.964,2.312h5.285Z",
    transform: "translate(-2646.948 -964.65)",
    fill: "#4a95cd",
    stroke: "#4a95cd",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28632",
    "data-name": "Path 28632",
    d: "M2920.761,1186.219a1.218,1.218,0,1,1-1.215,1.222A1.223,1.223,0,0,1,2920.761,1186.219Z",
    transform: "translate(-2899.968 -1170.306)",
    fill: "#4a95cd",
    stroke: "#4a95cd",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalExpense);
export default __webpack_public_path__ + "static/media/TotalExpense.8eda5984ed755aa1e1e0649eb53f763c.svg";
export { ForwardRef as ReactComponent };